import PageList from "../pagelist";

import ExEpubCFI from "./epubcfi";

class ExPageList extends PageList{
	constructor(xml) {
		super(xml);

        this.epubcfi = new ExEpubCFI();
	}
}

export default ExPageList;